/**
 * Created with Mei Zhiwei on 2017-10-26 16:58:50.
 * Description: cookie
 *
 * @author meizhiwei@meituan.com
 * @version 1.0.0
 * @Last Modified by: fanzhijie
 * @Last Modified time: 2018-02-08 15:24:45
 */
import { env } from '@/config';

const cookie = {
  // 使用方法：setCookie('username','Darren',86400)
  setCookie(cName, value, expireTime) {
    const cookieName = `${cName}`;
    const exdate = new Date();
    let domain = env === 'localhost' ? '' : ';domain=sankuai.com';
    exdate.setSeconds(exdate.getSeconds() + expireTime);
    document.cookie = `${env}${cookieName}=${escape(value)}${expireTime == null
      ? ''
      : `;expires=${exdate.toGMTString()}`};path=/${domain}`;
  },
  getCookie(cName) {
    const cookieName = `${env}${cName}`;
    let cStart;
    let cEnd;
    if (document.cookie.length > 0) {
      cStart = document.cookie.indexOf(`${cookieName}=`);
      if (cStart !== -1) {
        cStart = cStart + cookieName.length + 1;
        cEnd = document.cookie.indexOf(';', cStart);
        if (cEnd === -1) {
          cEnd = document.cookie.length;
        }
        return unescape(document.cookie.substring(cStart, cEnd));
      }
    }
    return '';
  }
};

export default cookie;



// WEBPACK FOOTER //
// ./src/lib/cookie.js